import React, { useLayoutEffect, useState } from "react";
import { getTransformSize, getTransformHandleLayout } from "./SharePreviewTransforms";

export default function ShareTransformHandles({ element, scene, metrics, trim, viewport, stageRef, onPointerDown, onKeyDown, disabled }) {
  const [textSize, setTextSize] = useState(null);
  useLayoutEffect(() => {
    if (element.kind !== "text" || !viewport.width) { setTextSize(null); return undefined; }
    const content = stageRef.current?.querySelector(".share-editor-text-item.is-selected .share-editor-text-content");
    if (!content) return undefined;
    const measure = () => {
      const ratio = viewport.width / scene.width;
      const next = { width: Math.max(8, content.offsetWidth / ratio), height: Math.max(8, content.offsetHeight / ratio) };
      setTextSize((previous) => previous?.width === next.width && previous?.height === next.height ? previous : next);
    };
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(content);
    return () => observer.disconnect();
  }, [element.id, element.kind, element.text, element.fontSize, viewport.width, scene.width, stageRef]);
  if (!viewport.width || !viewport.height) return null;
  const size = getTransformSize(element, scene, metrics, trim, textSize);
  const layout = getTransformHandleLayout(element, size, scene, viewport);
  return (
    <div className="share-editor-transform-handles">
      <svg className="share-editor-transform-frame" viewBox={`0 0 ${viewport.width} ${viewport.height}`} aria-hidden="true">
        <polygon points={layout.corners.map((corner) => `${corner.outline.x},${corner.outline.y}`).join(" ")} />
        <line x1={layout.rotation.edge.x} y1={layout.rotation.edge.y} x2={layout.rotation.position.x} y2={layout.rotation.position.y} />
      </svg>
      {layout.corners.map((corner) => (
        <button type="button" key={corner.id} className={`share-editor-transform-handle is-resize is-${corner.id}`} disabled={disabled}
          style={{ left: corner.position.x, top: corner.position.y }}
          aria-label={`Resize ${element.label} from ${corner.label}`} title="Drag to resize"
          onPointerDown={(event) => onPointerDown(event, "resize", corner, size)}
          onKeyDown={(event) => onKeyDown(event, "resize", corner, size)} onClick={(event) => event.stopPropagation()}>
          <span aria-hidden="true" />
        </button>
      ))}
      <button type="button" className="share-editor-transform-handle is-rotate" disabled={disabled}
        style={{ left: layout.rotation.position.x, top: layout.rotation.position.y }}
        aria-label={`Rotate ${element.label}`} title="Drag to rotate"
        onPointerDown={(event) => onPointerDown(event, "rotate", null, size)}
        onKeyDown={(event) => onKeyDown(event, "rotate", null, size)} onClick={(event) => event.stopPropagation()}>
        <span aria-hidden="true">↻</span>
      </button>
    </div>
  );
}
